import { render, staticRenderFns } from "./RequestsExpansionWorksWithWarnings.vue?vue&type=template&id=3a370a8a&"
import script from "./RequestsExpansionWorksWithWarnings.vue?vue&type=script&lang=js&"
export * from "./RequestsExpansionWorksWithWarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QField,QItemLabel,QIcon,QExpansionItem} from 'quasar'
component.options.components = Object.assign({QItem,QItemSection,QField,QItemLabel,QIcon,QExpansionItem}, component.options.components || {})
